/** Teto «redondo» do eixo, com a metade também inteira: 2, 4, 6, 8, 10, 20, 40, 50… */
export function niceMax(n: number): number {
  if (n <= 2) return 2;
  const p = 10 ** Math.floor(Math.log10(n));
  const steps = p === 1 ? [2, 4, 6, 8, 10] : [1, 2, 4, 5, 6, 8, 10];
  return steps.find((m) => m * p >= n)! * p;
}
